import { useSearchParams, useNavigate, Link, useParams, } from "react-router-dom";
import { useEffect,useLayoutEffect, useState } from "react";
import { HeartOutlined, LeftOutlined,HeartFilled } from "@ant-design/icons";
import { PageName, ThemeButton,ThemeCollapse, ToggleContainer, ToggleButton, ListIcon, GridIcon, ButtonContainer } from './style';
import { Card, Pagination, Collapse, Row, Col, Grid  } from "antd";
import { MySegmented, MyText } from "../../components";
import { fetchArticleList, fetchAutorsList } from '../../api'; 
import {useTranslation} from "react-i18next";
import {Cookies} from "react-cookie";
import { COOKIE_KEY, fetchArticleListAction, fetchAutorsListAction, fetchSetLikeAction, fetchThemeListAction } from "../../utils";
import { useEmbeddedNavigate, useEmbeddedLink } from "../../utils/context/embed";
import {Helmet} from "react-helmet";
import { useLang } from "../../utils/context/lang";
import { useDispatch, useSelector } from "react-redux";

const { Panel } = Collapse;
const isMobile = window.innerWidth < 768;

const AuthorArticlesPage = () => {
  const {t} = useTranslation("common")
  const dispatch = useDispatch();
  const themeList = useSelector((state: any) => state.articles.themeList);
  const themes = themeList.data || [];

  const [searchParams, setSearchParams] = useSearchParams();
  const [viewMode, setViewMode] = useState('grid');
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const themeParam: any = searchParams.get('theme');
  const segmentedParams: any = searchParams.get('type');
  const navigate = useNavigate();
  const embeddedNavigate = useEmbeddedNavigate();
  const embeddedLink = useEmbeddedLink();

  const { authorId } = useParams();
  const [activeKeyTheme, setActiveKeyTheme] = useState(null);
  // const [themes, setThemes] = useState([]);
  const [authorDetails, setAuthorDetails] = useState(null);
  const initialTopicIdRaw = searchParams.get('topic_id');
  const initialTopicId = initialTopicIdRaw ? Number(initialTopicIdRaw) : null;
  const [selectedSubThemeId, setSelectedSubThemeId] = useState(initialTopicId);
  const articleList = useSelector((state: any) => state.articles.articleList);
  const autorsList = useSelector((state: any) => state.articles.autorsList);
  const [likedArticles, setLikedArticles] = useState<{ [key: number]: boolean }>({});
    const [likeCounts, setLikeCounts] = useState<{ [key: number]: number }>({});
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();  
  const cookies = new Cookies()
  const isTablet = screens.md && !screens.xl && !screens.xxl;
  const {handleChangeLang, lang} = useLang()
  let token = cookies.get(COOKIE_KEY.ACCESS_TOKEN);

  const handleClick = () => {
  const topicPart = initialTopicId && initialTopicId !== '0' ? `&topic_id=${initialTopicId}` : '';
  embeddedNavigate(`/articles?type=authors${topicPart}`);
};
  const SPECIALIST_TYPE = [
    {
      key: 'articles',
      title: `${t("articles")}`
    },
    {
      key: 'authors',
      title: `${t("authors")}`
    },
  ];

  // useEffect(() => {
  //   const loadData = async () => {
  //     setLoading(true);
  //     try {
  //       if (segmentedParams === 'authors') {
  //         const authorList = await fetchAutorsList(); 
          
  //         setAuthorDetails(authorList.find(author => author.id === Number(authorId))); 
  //         const articleList = await fetchArticleList(null ,authorId); 
  //         setArticles(articleList.list);
  //       }
  //     } catch (error) {
  //       console.error('Error fetching data:', error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   loadData();
  // }, [segmentedParams, authorId]);

  useEffect(() => {
    if (segmentedParams === 'authors') {
      setLoading(true);
      dispatch(fetchAutorsListAction({}));
      if (authorId) dispatch(fetchArticleListAction({ author_id: authorId }));
    }
  }, [segmentedParams, authorId]);

  useEffect(() => {
    if (!autorsList.success || !autorsList.data) return;
    setAuthorDetails(autorsList.data.find((author: any) => author.id === Number(authorId)));
    setLoading(false);
  }, [autorsList.success, autorsList.data]);

  useEffect(() => {
    if (!articleList.success || !articleList.data) return;
    setArticles(articleList.data.list || []);
    setLoading(false);
  }, [articleList.success, articleList.data]);

  const formatDate = (dateString, lang) => {
    const date = new Date(dateString);
    const locale = lang === 'kk' ? 'kk-KZ' : 'ru-RU';
  
    const kazakhMonths = [
      'қаңтар', 'ақпан', 'наурыз', 'сәуір', 'мамыр', 'маусым',
      'шілде', 'тамыз', 'қыркүйек', 'қазан', 'қараша', 'желтоқсан'
    ];
  
    const optionsDate = { year: 'numeric', month: 'long', day: 'numeric' };
    const optionsTime = { hour: '2-digit', minute: '2-digit', hour12: false, hourCycle: 'h23' };
  
    let formattedDate = new Intl.DateTimeFormat(locale, optionsDate).format(date);
    const formattedTime = new Intl.DateTimeFormat(locale, optionsTime).format(date);
  
    if (lang === 'kk') {
      const monthIndex = date.getMonth();
      const kazakhMonth = kazakhMonths[monthIndex];
      
      formattedDate = formattedDate.replace(
        /(\d{1,2})\s[\wа-яё]+\s(\d{4})/i, 
        `$1 ${kazakhMonth} $2`
      );
    }
  
    return `${formattedDate} ${formattedTime}`.replace(/г\.\s*/, '');
  };


  const handleChangeSegmented = (value: any) => {
    if (value === 'articles') {
        setSearchParams({ type: 'articles' });
        embeddedNavigate('/articles?type=articles');
    } else {
        setSearchParams({ type: 'authors' });
    }
    };

    const handleChangeTheme = (theme: string) => {
        setSearchParams({ type: segmentedParams || 'articles', theme });
      };

      // const toggleLike = (articleId: number) => {
      //     setLikedArticles((prev) => ({
      //       ...prev,
      //       [articleId]: !prev[articleId],
      //     }));
      
      //     setLikeCounts((prev) => ({
      //       ...prev,
      //       [articleId]: prev[articleId] + (likedArticles[articleId] ? -1 : 1),
      //     }));
          
      //     fetchSetLike(articleId, 'article');
      //   };
    const toggleLike = (articleId: number) => {
      setLikedArticles((prev) => ({
        ...prev,
        [articleId]: !prev[articleId],
      }));
      setLikeCounts((prev) => ({
        ...prev,
        [articleId]: prev[articleId] + (likedArticles[articleId] ? -1 : 1),
      }));
      dispatch(fetchSetLikeAction({ entity_id: articleId, entity_type: 'article' }));
    };

    useLayoutEffect(() => {
        if (!segmentedParams) {
        handleChangeSegmented(SPECIALIST_TYPE[0].key);
        }
    }, []);

  //   useEffect(() => {
  //     const fetchContent = async () => {
  //         try {
  //             const response = await fetchThemeList();
  //             setThemes(response || []);
  //         } catch (error) {
  //             console.error('Error fetching themes:', error);
  //         }
  //     };
  
  //     fetchContent();
  // }, []);
  useEffect(() => {
    dispatch(fetchThemeListAction({}));
  }, []);

  useEffect(() => {
    const fetchContent = async () => {
        try {
            const response = await fetchArticleList(null ,authorId);
            setArticles(response.list || []);
        } catch (error) {
            console.error('Error fetching themes:', error);
        }
    };

    fetchContent();
}, []);

useEffect(() => {
  if (!Array.isArray(articles)) return;
  const initialLikes: { [key: number]: boolean } = {};
  const initialLikeCounts: { [key: number]: number } = {};

  articles.forEach((article) => {
    initialLikes[article.id] = article.is_liked_by_user;
    initialLikeCounts[article.id] = article.like_count;
  });

  setLikedArticles(initialLikes);
  setLikeCounts(initialLikeCounts);
}, [articles]);
  
  const parentThemes = themes.filter(theme => theme.parent_id === 0);
  
      const handlePanelChange = (key) => {
          setActiveKeyTheme(activeKeyTheme === key ? null : key);
      };
  

  return (
    <>
      <Helmet>
        <title>Статьи для родителей и педагогов</title>
        <meta name="description" content="Полезные статьи для родителей и педагогов: развитие, воспитание, обучение детей от раннего возраста до дошкольного" />
      </Helmet>

    <Row style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
      <Row justify='center'>
      <Col span={20} >
      <Row justify="space-between" align="middle" gutter={[32, 24]}>

        <div style={{ marginBottom: screens.xs ? "0px" : '24px' }}>
          <MySegmented
            type='primary'
            options={SPECIALIST_TYPE.map(item => ({
              label: item.title,
              value: item.key
            }))}
            onChange={handleChangeSegmented}
            value={segmentedParams}
          />
        </div>

        <Row style={{ width: '100%' }} gutter={[screens.xs ? 0 : 24,screens.xs ? 0 : 24]}>
          <Col span={screens.xs || isTablet ? 24 : 18}>
            <Card style={{ width: '100%', borderRadius: '20px' }}>
            <PageName>
              <div
                style={
                  screens.xs
                    ? { marginBottom: 0 }
                    : {
                        display: 'flex',
                        gap: '32px',
                        justifyContent: 'space-between',
                        marginBottom: '24px',
                        alignItems: 'center',
                      }
                }
              >
                {/* <div style={{ display: 'flex', gap: '24px', alignItems: 'center'}}>
                    <ButtonContainer onClick={handleClick}>
                        <LeftOutlined style={{ color: 'rgba(10, 3, 60, 0.7)' }} />
                    </ButtonContainer>
                    <MyText color="#0A033C" size={32} weight={800} style={{ fontFamily: 'Nunito' }}>
                        {authorDetails ? authorDetails.fio : 'Загрузка статей...'}
                    </MyText>
                </div> */}                
                <Row align="middle" style={{height: '60px', width: screens.xs ? 'auto' : '530px'}}>
                {/* {!screens.xs && ( */}
                  <Col span={screens.xs ? 4 : 3}>
                  
                          <ButtonContainer onClick={handleClick}>
                            <LeftOutlined style={{color: 'rgba(10, 3, 60, 0.7)'}}/>
                          </ButtonContainer>
                          </Col>
                {/* )} */}
                          <Col span={screens.xs ? 18 : 21}>

                          <MyText color="#0A033C" size={screens.xs ? 24 : 26} weight={800}
                                  style={{fontFamily: 'Nunito', display: 'block', marginLeft: screens.xs ? 12: 12}}>
                            {authorDetails ? authorDetails.fio : t("articlesLoading")}
                          </MyText>
                          </Col>
                        </Row>

                  {!screens.xs && segmentedParams === 'authors' && (
                    <ToggleContainer>
                        <ToggleButton active={viewMode === 'list'} onClick={() => setViewMode('list')}>
                        <ListIcon active={viewMode === 'list'}>
                            <div className="line"></div>
                            <div className="line"></div>
                        </ListIcon>
                        </ToggleButton>
                        <ToggleButton active={viewMode === 'grid'} onClick={() => setViewMode('grid')}>
                        <GridIcon active={viewMode === 'grid'}>
                            <div className="grid-cell"></div>
                            <div className="grid-cell"></div>
                            <div className="grid-cell"></div>
                            <div className="grid-cell"></div>
                        </GridIcon>
                        </ToggleButton>
                    </ToggleContainer>
                    )}
                </div>
            
                    <div style={{
                        display: screens.xs ? 'flex' : (viewMode === 'grid' ? 'grid' : 'flex'),

                        // display: viewMode === 'grid' ? 'grid' : 'flex',
                        gridTemplateColumns:
                          viewMode === 'grid'
                            ? isTablet
                              ? 'repeat(2, 1fr)'
                              : 'repeat(3, 1fr)'
                            : 'none',
                        gap: '24px',
                        flexWrap: 'wrap',
                    }}>
                    {loading ? (
                    <div>Loading...</div>
                    ) : (
                    articles.map((article) => (
                        <div key={article.id} style={{
                        display: 'flex',
                        marginTop: '24px',
                        width: '100%',
                        flexDirection: viewMode === 'grid' ? 'column' : 'row',
                        }}>
                        <div style={{
                            width: viewMode === 'grid' ? '100%' : '240px',
                            height: isTablet ? '224px' : '188px',
                            borderRadius: '12px',
                            overflow: 'hidden'
                        }}>
                            <img 
                            src={article.image}
                            alt="Article"
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover'
                            }}
                            />
                        </div>
                        
                        <div style={{ display: 'flex', gap: '16px', marginLeft: viewMode === 'grid' ? '0' : '24px', width: '100%', flexDirection: 'column', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center', marginTop: '12px' }}>
                              <div style={{ display: 'flex', gap: viewMode === 'grid' ? '6px' : '8px', alignItems: 'center' }}>
                                {/* <Col> */}
                                {(likedArticles[article.id] ?? article.is_liked_by_user) ? (
                                <HeartFilled
                                  style={{
                                    fontSize: "16px",
                                    color: "rgba(253, 99, 99, 1)",
                                    cursor: "pointer",
                                  }}
                                  onClick={token ? () => toggleLike(article.id) : undefined}
                                />
                              ) : (
                                <HeartOutlined
                                  style={{
                                    fontSize: "16px",
                                    color: "rgba(104, 114, 125, 1)",
                                    cursor: "pointer",
                                    height: '24px'
                                  }}
                                  onClick={token ? () => toggleLike(article.id) : undefined}
                                />
                              )}
                            {/* </Col> */}
                            {/* <Col> */}
                            {likeCounts[article.id] > 0 && (
                              <MyText color="rgba(104, 114, 125, 1)" size={16} lineHeight="24px">
                                {likeCounts[article.id]}
                              </MyText>
                            )}
                            {/* </Col> */}
                              </div>
                              <MyText color='rgba(104, 114, 125, 1)' size={16}>
                                {formatDate(article.created_at, lang)}
                              </MyText>
                            </div>
                            <MyText color='#0A033C' size={viewMode === 'grid' ? 18 : 22} weight={700} style={{ fontFamily: 'Nunito', height: viewMode === 'grid' ? '42px' : 'auto', }}>
                            {article.header.length > 50 ? `${article.header.slice(0, 45)}...` : article.header}
                            </MyText>
                            <MyText 
                            color='#0A033C' 
                            size={viewMode === 'grid' ? 16 : 16} 
                            lineHeight={viewMode === 'grid' ? "20px" : "24px"} 
                            style={{ fontFamily: 'Nunito', height: viewMode === 'grid' ? '72px' : 'auto', }}
                            >
                            {viewMode === 'grid' 
                              ? article.content.replaceAll('&nbsp;', ' ').slice(0, 90) + (article.content.length > 90 ? '...' : '') 
                              : article.content.replaceAll('&nbsp;', ' ').slice(0, 140) + (article.content.length > 100 ? '...' : '')}
                            </MyText>
                            <Link to={embeddedLink(`/articles/${article.id}?type=articles`)} >
                            <MyText color='rgba(0, 141, 210, 1)' size={18} weight={600}>
                              {t("moreDetails")} →
                            </MyText>
                            </Link>
                        </div>
                        </div>
                    ))
                    )}
                    </div>
                    {/* {articles.length > 6 && (
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '32px' }}>
                  <Pagination defaultCurrent={1} total={articles.length} />
                        </div>
              )} */}
                </PageName>
            </Card>
            </Col>

            {!(screens.xs || isTablet) && (
            <Col span={6}>
            <Card style={{ width: '100%', borderRadius: '20px' }}>
            <PageName>
              <MyText color="#0A033C" size={18} weight={800} style={{ marginBottom: '16px', fontFamily: 'Nunito' }}>
                  {t("topics")}
              </MyText>      
            {[{ id: null, name: t("all") }, ...parentThemes].map(parentTheme => {
  const childThemes = parentTheme.id ? themes.filter(theme => theme.parent_id === parentTheme.id) : [];

  return childThemes.length === 0 ? (
    <li
      key={parentTheme.id ?? 'all'}
      style={{ marginBottom: '8px', cursor: 'pointer', fontSize: '18px' }}
      onClick={async () => {
        setActiveKeyTheme(null);
        setSelectedSubThemeId(parentTheme.id); 
        setSearchParams(prevParams => {
          if (parentTheme.id === null) {
            prevParams.delete('topic_id');
          } else {
            prevParams.set('topic_id', parentTheme.id);
          }
          return prevParams;
        });
        try {
          const response = await fetchArticleList(null, authorId, parentTheme.id); 
          setArticles(response.list);
        } catch (error) {
          console.error('Error fetching content by topic:', error);
        }
      }}
    >
      <div
        style={{
          background: selectedSubThemeId === parentTheme.id ? "rgba(231, 250, 255, 1)" : '#fff',
          borderRadius: '8px',
          padding: '12px',
          border: '1px solid #d9d9d9'
        }}
      >
        <MyText
          color={selectedSubThemeId === parentTheme.id ? 'rgba(0, 141, 210, 1)' : '#0A033C'}
          size={18}
          weight={600}
        >
          {parentTheme.name}
        </MyText>
      </div>
    </li>
  ) : (
    <ThemeCollapse
      activeKey={activeKeyTheme}
      onChange={handlePanelChange}
      style={{ marginBottom: '8px', background: '#fff' }}
      key={parentTheme.id}
    >
      <Panel
        header={
          <MyText color="#0A033C" size={18} weight={600}>
            {parentTheme.name}
          </MyText>
        }
        key={parentTheme.id}
      >
        <ul style={{ padding: 0, listStyleType: 'none' }}>
          {childThemes.map(subTheme => (
            <li
              key={subTheme.id}
              style={{
                marginBottom: '8px',
                cursor: 'pointer',
                fontSize: '18px',
                color: selectedSubThemeId === subTheme.id ? 'rgba(0, 141, 210, 1)' : '#0A033C'
              }}
              onClick={async () => {
                setSelectedSubThemeId(subTheme.id);
                setSearchParams(prevParams => {
                  prevParams.set('topic_id', subTheme.id);
                  return prevParams;
                });
                try {
                  const response = await fetchArticleList(null, authorId, subTheme.id);
                  setArticles(response.list);
                } catch (error) {
                  console.error('Error fetching content by topic:', error);
                }
              }}
            >
              {subTheme.name}
            </li>
          ))}
        </ul>
      </Panel>
    </ThemeCollapse>
  );
})}
          </PageName>
          </Card>
          </Col>
            )}
        
          </Row>
        </Row>
        </Col>
      </Row>
    </Row>
    </>
  );
};

export default AuthorArticlesPage;
